.panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: var(--color-surface);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: none;
  min-height: var(--tabbar-height);
  padding: 0 var(--spacing-md);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
}

.title {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-text);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
